function routingMiddleware() {
  return (next) => (action) => {
    next(action);
  };
}

export default routingMiddleware;
